import type { FC } from 'react'
import { useQuery, useQueryClient } from 'react-query'
import { Skeleton, Text, Button, Link } from '@chakra-ui/react'
import {
	ContentSection,
	ContentSectionHeading,
} from '@alexanderathoodly/ui-library'

import { getLocationByUrlQuery } from '~/queries/coworking_location'
import { getProviderQuery } from './queries'
import { useTranslation } from 'react-i18next'

const ProviderSection: FC<{ url: string }> = ({ url }) => {
	const { t, i18n } = useTranslation()
	const locationResult = useQuery(getLocationByUrlQuery(url, useQueryClient()))
	const providerResult = useQuery(
		getProviderQuery(locationResult.data?.provider)
	)
	return providerResult.data ? (
		<ContentSection>
			<ContentSectionHeading>{`${t('Om')} ${
				providerResult.data.name
			}`}</ContentSectionHeading>
			<Text whiteSpace="pre-wrap" color="grey.500">
				{i18n.language != 'en'
					? providerResult.data.description
					: providerResult.data.description_en}
			</Text>
			{locationResult.data?.is_premium_listing && (
				<Button
					as={Link}
					variant="link"
					mt={2}
					fontSize="sm"
					href={`${t('/operatörer', { ns: 'url' })}/${providerResult.data.id}`}
				>
					{t('Läs mer')}
				</Button>
			)}
		</ContentSection>
	) : (
		<Skeleton />
	)
}

export default ProviderSection
